export const CHANGE_CATEGORY = "CHANGE_CATEGORY";
//! tüm categoryleri listeleme
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
//! seçili kategorigedeki ürünleri listeleme
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
// //! sepete ekleme
// export const ADD_TO_CART = "ADD_TO_CART";
// export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
//! veri tabanına ürün ekleme
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
//! ürün güncelleme
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
//! ürün silme
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
